<template>
    <toolbar-option>
        <template slot="primary">
            <input
                v-model="value"
                type="text"
                placeholder="Add text"
                @change="setChangedData(true)"
            >
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'input-placeholder',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Placeholder',
            value: '',
        };
    },

    watch: {
        value() {
            this.selectedElements[0].placeholderNew = this.value;
            this.onOptionChange(this.value);
        },
    },

    methods: {
        onSelectedElement() {
            this.value = this.selectedElements[0].placeholderNew;
        },
    },
};
</script>
